// extracted by mini-css-extract-plugin
export default {"overlay":"Gz-z","bodyOpen":"Hz-z","content":"Iz-z","header":"Jz-z","close":"Kz-z","closeNoHeading":"Lz-z"};